import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import unlockTherapistService from 'src/services/apiServices/unlockTherapist/unlockTherapistService';
import { unlockTherapistConstant } from '../../actions/constant';

const {
  POST_UNLOCK_THERAPIST_REQUEST,
  POST_UNLOCK_THERAPIST_SUCCESS,
  POST_UNLOCK_THERAPIST_FAILURE,
  POST_UNLOCK_THERAPIST_RESET,
  POST_UNLOCK_THERAPIST_LOADING,
} = unlockTherapistConstant;

function* updateUnlockTherapist(action: any): SagaReturnType<any> {
  try {
    yield put({ type: POST_UNLOCK_THERAPIST_LOADING });

    const response = yield call(unlockTherapistService.updateUnlockTherapist, action?.payload);
    if (response?.status === 200) {
      yield put({ type: POST_UNLOCK_THERAPIST_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: POST_UNLOCK_THERAPIST_FAILURE, payload: error });
  }
}

function* updateUnlockTherapistSaga() {
  yield takeEvery(POST_UNLOCK_THERAPIST_REQUEST, updateUnlockTherapist);
}

export default updateUnlockTherapistSaga;
